// Salesforce multi-select picklists return selected values joined by ";".
export function splitSalesforceMultiSelect(value?: string | null): Array<string> {
  if (!value) {
    return [];
  }

  return value
    .split(';')
    .map((entry) => entry.trim())
    .filter(Boolean);
}
